module.exports = "<credits-page></credits-page>\n";


//////////////////
// WEBPACK FOOTER
// ./src/views/appSettings/credits.html
// module id = 1745
// module chunks = 0